import { createFileRoute, Navigate } from '@tanstack/react-router';

const NavigateToChannel = () => {
  const { id } = Route.useParams();
  return <Navigate to={`/safety-check/e/${id}` as string} />;
};

export const Route = createFileRoute('/safety-check/$id/')({
  component: NavigateToChannel,
});
